import React,{useState, useEffect} from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Row,Col } from 'react-bootstrap';

import "./CashCount.css"
import NavbarAdmin from '../../../Components/NavbarAdmin/NavbarAdmin';
import { formatDateNoTime, numberFormat} from '../../../Helpers/Utils/Common';
import { getSales, showCashCount } from '../../../Helpers/apiCalls/reportsAPI';

function ViewCashCount() {
    const navigate = useNavigate()
    const {id} = useParams()

    const [inactive, setInactive] = useState(true)
    const [details, setDetails] = useState({})
    const [drawerYesterday, setDrawerYesterDay] = useState(0)
    const [totalCash, setTotalCash] = useState(0)
    const [card, setCard] = useState(0)
    const [check, setCheck] = useState(0)
    const [others, setOthers] = useState(0)

    async function fetchCashCount(){
        var totalcash = 0
        const response = await showCashCount(id)
        if(response.data){
            setDetails(response.data.message.cash_count[0])
            totalcash = parseFloat(response.data.message.cash_count[0].physical_count) + parseFloat(response.data.message.cash_count[0].initial_drawer)
            const response1 = await showCashCount(parseInt(id)-1)
                if(response1.data){
                    setDrawerYesterDay(response1.data.message.cash_count[0].initial_drawer)
                    totalcash = totalcash - parseFloat(response1.data.message.cash_count[0].initial_drawer)
                }
        }
        setTotalCash(totalcash)
        
    }

    async function fetchCardSales(){
        const response = await getSales("card")
        if(response.data){
            setCard(response.data.message.data.map(data => parseFloat(data.total_sales)).reduce((a,b)=> a + b, 0).toFixed(2))
        }
    }

    async function fetchCheckSales(){
        const response = await getSales("check")
        if(response.data){
            setCheck(response.data.message.data.map(data => parseFloat(data.total_sales)).reduce((a,b)=> a + b, 0).toFixed(2))
            // setCheck(response.data.message.data[0].total_sales)
        }
    }

    async function fetchOthersSales(){
        const response = await getSales("others")
        if(response.data){
            setOthers(response.data.message.data.map(data => parseFloat(data.total_sales)).reduce((a,b)=> a + b, 0).toFixed(2))
            // setOthers(response.data.message.data[0].total_sales)
        }
    }

    useEffect(()=>{
        fetchCashCount()
        fetchCardSales()
        fetchCheckSales()
        fetchOthersSales()
    },[])

  return (
    <div>
         <NavbarAdmin
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                     }}
                    active={"Reports"} //Dashboard navbar index
                    page={"Reports"}
        />
        <div className={`container bold-font ${inactive ? "inactive" : "active"}`} id="forPrinting">
        <Row className="mb-3">
            <Col xl={6}>
              <h1 className="page-title-menu">VIEW CASH COUNT </h1>
            </Col>
            </Row>
            <hr/>
            <Row className="b-shadow count rounded">
                <Col xs={12} className="p-4">
                    <Row className="mb-2">
                        <Col xs={4}>Count Date</Col>
                        <Col xs={1}>:</Col>
                        <Col >{formatDateNoTime(new Date())}</Col>
                    </Row>
                    <Row>
                        <Col xs={4}>Cash in Drawer(yesterday)</Col>
                        <Col xs={1}>:</Col>
                        <Col >₱ {numberFormat(parseFloat(drawerYesterday))}</Col>
                    </Row>
                    <Row>
                        <Col xs={4}>Cash Remitted</Col>
                        <Col xs={1}>:</Col>
                        <Col >₱ {numberFormat(parseFloat(details.physical_count))}</Col>
                    </Row>
                    <Row>
                        <Col xs={4}>Cash left in Drawer</Col>
                        <Col xs={1}>:</Col>
                        <Col >₱ {numberFormat(parseFloat(details.initial_drawer))}</Col>
                    </Row>
                    <Row>
                        <Col xs={8}><hr/></Col>
                    </Row>
                    <Row>
                        <Col xs={4}>TOTAL CASH</Col>
                        <Col xs={1}>:</Col>
                        <Col >₱ {totalCash > 0 ? numberFormat(totalCash.toFixed(2)):numberFormat(totalCash)}</Col>
                    </Row>
                    <Row>
                        <Col xs={4}>OVER/SHORT</Col>
                        <Col xs={1}>:</Col>
                        <Col >₱ {details.overage > 0? numberFormat(parseFloat(details.overage).toFixed(2)):numberFormat(details.overage)}</Col>
                    </Row>
                </Col>

                <Col xs={12} className="p-4">
                    <Row>
                        <Col xs={4}>TOTAL CASH SALES</Col>
                        <Col xs={1}>:</Col>
                        <Col >₱ {numberFormat(totalCash.toFixed(2))}</Col>
                    </Row>
                    <Row>
                        <Col xs={4}>TOTAL CARD SALES</Col>
                        <Col xs={1}>:</Col>
                        <Col >₱ {numberFormat(parseFloat(card).toFixed(2))}</Col>
                    </Row>
                    <Row>
                        <Col xs={4}>TOTAL CHECK SALES</Col>
                        <Col xs={1}>:</Col>
                        <Col >₱ {numberFormat(parseFloat(check).toFixed(2))}</Col>
                    </Row>
                    <Row>
                        <Col xs={4}>TOTAL OTHERS SALES</Col>
                        <Col xs={1}>:</Col>
                        <Col >₱ {others !== null && others!=="" ? numberFormat(parseFloat(others).toFixed(2)):"0.00"}</Col>
                    </Row>
                    <Row>
                        <Col xs={8}><hr/></Col>
                    </Row>
                    <Row>
                        <Col xs={4}><h5>TOTAL SALES</h5></Col>
                        <Col xs={1}><h5>:</h5></Col>
                        <Col ><h5>₱ {(totalCash+parseFloat(card)+parseFloat(check)+(others !== null && others!=="" ? parseFloat(others):0)) > 0 ?
                        numberFormat((totalCash+parseFloat(card)+parseFloat(check)+(others !== null && others!=="" ? parseFloat(others):0)).toFixed(2))
                        :
                        numberFormat(totalCash+parseFloat(card)+parseFloat(check)+(others !== null && others!=="" ? parseFloat(others):0))}</h5></Col>
                    </Row>
                </Col>
            </Row>
            <div className='d-flex row justify-content-end mt-3'>
                <div className='col-12 mb-3 pl-93'>
                    <button className="btn btn-success" onClick={()=>navigate(-1)}>Back</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ViewCashCount